<template>
    <span class="d-flex flex-column">
        <span class="w-100 text-center p-0 m-0">
            <span v-if="value !== null && value !== undefined && typeof value === 'boolean'">
                <b-icon icon="check" variant="success" v-if="getValue()" scale="2" />
                <b-icon icon="x" variant="danger" v-else scale="2"/>
            </span>
            <span v-else class="text-secondary"><img :src="ban"/></span>
        </span>
        <slot name="secondary">
        </slot>
    </span>
</template>

<script>
    import ban from '../../assets/img/ban.svg'
export default {
    name: "AnimalAliveCell",
    props: {
        value: {}
    },
    data() {
        return {
            ban
        }
    },
    methods: {
        getValue() {
            return Boolean(this.value)
        }
    }
}
</script>

<style scoped>

</style>